import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { AutoCloseable1l5p57f9lp7kv as AutoCloseable } from '../../../kotlin-kotlin-stdlib/kotlin/AutoCloseableJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PeekSourceClass;
function PeekSource() {
  if (PeekSourceClass === VOID) {
    class $ {
      constructor(upstream) {
        this.upstream_1 = upstream;
        this.buffer_1 = this.upstream_1.get_buffer_bmaafd_k$();
        this.expectedSegment_1 = this.buffer_1.head_1;
        var tmp = this;
        var tmp0_safe_receiver = this.buffer_1.head_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pos_1;
        tmp.expectedPos_1 = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        this.closed_1 = false;
        this.pos_1 = 0n;
      }
      readAtMostTo_4oop6l_k$(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!!this.closed_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        // Inline function 'kotlin.check' call
        if (!(this.expectedSegment_1 == null || (this.expectedSegment_1 === this.buffer_1.head_1 && this.expectedPos_1 === ensureNotNull(this.buffer_1.head_1).pos_1))) {
          var message_1 = 'Peek source is invalid because upstream source was used';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_1));
        }
        if (byteCount === 0n)
          return 0n;
        // Inline function 'kotlin.Long.plus' call
        var this_0 = this.pos_1;
        var tmp$ret$7 = add(this_0, fromInt(1));
        if (!this.upstream_1.request_hj5jqj_k$(tmp$ret$7))
          return -1n;
        if (this.expectedSegment_1 == null && !(this.buffer_1.head_1 == null)) {
          this.expectedSegment_1 = this.buffer_1.head_1;
          this.expectedPos_1 = ensureNotNull(this.buffer_1.head_1).pos_1;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = subtract(this.buffer_1.get_size_woubt6_k$(), this.pos_1);
        var toCopy = byteCount <= b ? byteCount : b;
        this.buffer_1.copyTo_xutsee_k$(sink, this.pos_1, add(this.pos_1, toCopy));
        this.pos_1 = add(this.pos_1, toCopy);
        return toCopy;
      }
      close_yn9xrc_k$() {
        this.closed_1 = true;
      }
    }
    initMetadataForClass($, 'PeekSource', VOID, VOID, [AutoCloseable()]);
    PeekSourceClass = $;
  }
  return PeekSourceClass;
}
//region block: exports
export {
  PeekSource as PeekSource3frbthc9yehpr,
};
//endregion

//# sourceMappingURL=PeekSource.mjs.map
